import { PostServiceM3 } from "../../ConexionSQL/posts.service";
import { M3Procesos } from "../Registro/m3-procesos";

export class M3ProcesoService {

    public add_procesoEA(PostServiceM3: PostServiceM3, sIDKatios: string,
        jData: any, funcionOK: Function, funcionError: Function) {
        PostServiceM3.postServiceHttpResFullM3("ProcesosM3/add_procesoEA/" + sIDKatios, jData).subscribe(resp => {
            //var oJson = JSON.parse(resp.json());

            funcionOK(resp);
        },
            err => {
                //this.enProceso = false;
                console.error(err.json().Message);
                funcionError(err.json().Message);
            });
    }

    //Obtener la lista de producto, teniendo en cuenta, un array de filtros.
    M3Get_ProcesosPorCantidad(PostServiceM3: PostServiceM3, sIDKatios: string,
        oFuncionOK: Function, oFuncionErr: Function) {

        PostServiceM3.getM3('ProcesosM3/M3Get_ProcesosPorCantidad/' + sIDKatios).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            var olProcesos;
            olProcesos = JSON.parse(resp);

            if (olProcesos.RESPUESTA.TP.length === undefined) {
                olProcesos.RESPUESTA.TP = new Array(olProcesos.RESPUESTA.TP);
            }

            oFuncionOK(olProcesos);
        },
            err => {
                //Ejecutar funcion de error
                oFuncionErr(err.error.Message);
            });
    }



    //Obtener la lista de producto, teniendo en cuenta, un array de filtros.
    public M3Get_ActividadesYProcesos(PostServiceM3: PostServiceM3, sIDKatios: string, oData: any,
        oFuncionOK: Function, oFuncionErr: Function) {

        PostServiceM3.getWithBodyM3('ProcesosM3/M3Get_ActividadesYProcesos/' + sIDKatios, oData).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            var olProcesos;
            olProcesos = JSON.parse(resp.toString());

            //Si las actividades no vienen como un array, convertirlo
            if (olProcesos.RESPUESTA.ACTIVIDADES.length === undefined) {
                olProcesos.RESPUESTA.ACTIVIDADES = new Array(olProcesos.RESPUESTA.ACTIVIDADES);
            }

            //Si los procesos no vienen como un array, convertirlo
            olProcesos.RESPUESTA.ACTIVIDADES.forEach(Actividad => {
                if (Actividad.PROCESOS !== undefined && Actividad.PROCESOS.length === undefined) {
                    Actividad.PROCESOS = new Array(Actividad.PROCESOS);
                }
            });

            oFuncionOK(olProcesos);
        },
            err => {
                console.log(err);
                //Ejecutar funcion de error
                oFuncionErr(err.error.Message);
            });
    }



    //Obtener la lista de producto, teniendo en cuenta, un array de filtros.
    public M3Get_M3ProcesosByIdProceso(PostServiceM3: PostServiceM3, sIDKatios: string, oData: any, sIdProceso: string,
        oFuncionOK: Function, oFuncionErr: Function) {

        PostServiceM3.getWithBodyM3('ProcesosM3/M3Get_M3ProcesosByIdProceso/' + sIDKatios + '/' + sIdProceso, oData).subscribe(resp => {
            //Ejecutar funcion de procesamiento OK
            var olProcesosM3;
            olProcesosM3 = JSON.parse(resp.toString());

            //Si las actividades no vienen como un array, convertirlo
            if (olProcesosM3.RESPUESTA.SUBESTADOS.length === undefined) {
                olProcesosM3.RESPUESTA.SUBESTADOS = new Array(olProcesosM3.RESPUESTA.SUBESTADOS);
            }

            //Si los procesos no vienen como un array, convertirlo
            olProcesosM3.RESPUESTA.SUBESTADOS.forEach(subs => {
                if (subs.M3PROCESOS !== undefined && subs.M3PROCESOS.length === undefined) {
                    subs.M3PROCESOS = new Array(subs.M3PROCESOS);
                }
            });

            oFuncionOK(olProcesosM3);
        },
            err => {
                //console.log(JSON.parse(err._body).Message);
                //Ejecutar funcion de error
                oFuncionErr(JSON.parse(err._body).Message);
            });
    }



    //Obtener informacion de M3procesos, desde el iddiario.
    public async GetM3ProcesosByIdDiario(PostServiceM3: PostServiceM3, sIDKatios: string, sIdDiario: string) {

        var oData;
        oData = { "IdDiario": sIdDiario };
        var oM3Proceso;
        oM3Proceso = await PostServiceM3.getWithBodyM3('ProcesosM3/GetM3ProcesosByIdDiario/' + sIDKatios, oData).toPromise();

        return oM3Proceso;
    }

    //Obtener informacion de M3procesos, Teniendo el IDM3.    
    public M3Get_M3ProcesosByIdM3(PostServiceM3: PostServiceM3, sIDKatios: string, sIDM3: string, sIdProceso: string, sUbicacion: string,
        oFuncionOK: Function, oFuncionErr: Function, ubicExterno = false, bAPLPagosPD = false) {

        var oData;
        oData = { "IdM3": sIDM3, "IdProceso": sIdProceso };
        if (bAPLPagosPD) {
            oData.bAPLPagosPD = true;
        }

        PostServiceM3.getWithBodyM3('ProcesosM3/GetProcesoM3ByIdM3/' + sIDKatios, oData).subscribe(resp => {
            var oM3Procesos: any;
            oM3Procesos = resp;

            //Validar que la ubicacion actuales valida para el proceso
            //pcastro, se comentarea porque no funciona con tf, retorna para TF SIEMPRE NULL, no se maneja ubicaciones
            //Se coloca dif a 0, por version TF, que no utiliza funcionalidad de Ubicaciones
            if (oM3Procesos.M3FTrabajo.IdUbicPre.toString() != "0" && oM3Procesos.M3FTrabajo.IdUbicPre.toString() != sUbicacion.toString()) {
                if (!ubicExterno) {
                    oM3Procesos = null;
                }
            }
            oFuncionOK(oM3Procesos);
        },
            err => {
                oFuncionErr(err.error.Message);
            });
    }

    /**
     * Retoma el proceso que tiene por dinamica _IDM3Retomado el idm3 envaido por parametro
     * @param PostServiceM3 
     * @param sIDKatios 
     * @param sIDM3 
     * @param oFuncionOK 
     * @param oFuncionErr 
     */
    public getM3ProcesosByIdM3Retomado(PostServiceM3: PostServiceM3, sIDKatios: string, sIDM3: string,
        oFuncionOK: Function, oFuncionErr: Function) {

        var oData;
        oData = { "idM3Retomado": sIDM3 };

        PostServiceM3.getWithBodyM3('ProcesosM3/getM3ProcesosByIdM3Retomado/' + sIDKatios, oData).subscribe(resp => {

            oFuncionOK(resp);
        },
            err => {
                oFuncionErr(err.error.Message);
            });
    }




    /**
     * Obtener proceso M3, teniendo en cuenta el Id M3 y Idproceso
     * @param PostServiceM3 
     * @param sIDKatios 
     * @param sIDM3 
     * @param sIdProceso 
     * @param sUbicacion 
     */
    public async M3Get_M3ProcesosByIdM3Async(PostServiceM3: PostServiceM3, sIDKatios: string, sIDM3: string,
        sIdProceso: string, sUbicacion: string, bAPLPagosPD: boolean = false) {

        var oData;
        oData = { "IdM3": sIDM3, "IdProceso": sIdProceso };
        var resp;
        if (bAPLPagosPD) {
            oData.bAPLPagosPD = true;
        }
        resp = await PostServiceM3.getWithBodyM3('ProcesosM3/GetProcesoM3ByIdM3/' + sIDKatios, oData).toPromise();
        return resp;

    }

    /**
     * Obtener proceso M3, teniendo en cuenta el IdDiario
     * @param PostServiceM3 
     * @param sIDKatios 
     * @param idDiario 
     */
    public async m3_getProcesoM3ByIdDiarioAsync(PostServiceM3: PostServiceM3, sIDKatios: string, idDiario: string) {
        var oData;
        oData = { "idDiario": idDiario };
        var resp: any = await PostServiceM3.getWithBodyM3('ProcesosM3/m3_getProcesoM3ByIdDiario/' + sIDKatios, oData).toPromise();
        return resp;
    }


    ///Obtiene la esturcturas de las capturas dinamicas asociadas aun proceos y un idproceso
    public m3_get_data_capt_dinam(PostServiceM3: PostServiceM3, id_katios: string, oData: any,
        oFuncionOK: Function, oFuncionErr: Function) {
        ///oData = {"id_proceso":"","id_sub_proceso":""};
        PostServiceM3.getWithBodyM3('ProcesosM3/m3_get_data_capt_dinam/' + id_katios, oData).subscribe(resp => {
            oFuncionOK(resp);
        },
            err => {
                oFuncionErr(JSON.parse(err._body).Message);
            });
    }

    // /**
    //  * Retorna el RPTemplate para el armado del Reporte
    //  * @param PostServiceM3 
    //  * @param id_katios 
    //  * @param id_rep 
    //  */
    // public async get_template_reporte(PostServiceM3: PostServiceM3, id_katios: string, id_rep: string) {
    //     var oData;
    //     var resp;
    //     var oJson;
    //     oData = { "id_rep": id_rep };
    //     try {
    //         resp = await PostServiceM3.getWithBodyM3('ProcesosM3/get_template_reporte/' + id_katios, oData).toPromise();
    //         oJson = JSON.parse(resp);
    //         return oJson;
    //     }
    //     catch{
    //         return null;
    //     }
    // }

    /**
     * Obtener los procesos asociados a una persona
     * @param PostServiceM3 
     * @param id_katios 
     * @param oData 
     * @param oFuncionOK 
     * @param oFuncionErr 
     */
    public M3GetProcesoByPersona(PostServiceM3: PostServiceM3, id_katios: string, oData: any,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getWithBodyM3('ProcesosM3/M3GetProcesoByPersona/' + id_katios, oData).subscribe(resp => {
            oFuncionOK(resp);
        },
            err => {
                oFuncionErr(JSON.parse(err._body).Message);
            });
    }



    public M3GetProcesoByIdDiarioCierre(PostServiceM3: PostServiceM3, id_katios: string, oData: any,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getWithBodyM3('ProcesosM3/M3GetProcesoByIdDiarioCierre/' + id_katios, oData).subscribe(resp => {
            oFuncionOK(resp);
        },
            err => {
                oFuncionErr(JSON.parse(err._body).Message);
            });
    }




    /**
     * Obtener informacion de procesos Off line
     * @param PostServiceM3 
     * @param id_katios 
     * @param oData 
     * @param oFuncionOK 
     * @param oFuncionErr 
     */
    public M3GetProcesosOffLine(PostServiceM3: PostServiceM3, id_katios: string, oData: any,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getWithBodyM3('ProcesosM3/M3GetProcesosOffLine/' + id_katios, oData).subscribe(resp => {
            oFuncionOK(resp);
        },
            err => {
                oFuncionErr(JSON.parse(err._body).Message);
            });
    }

    /**
     * Retoena el TDetalleProceso de un proceso dado
     * @param PostServiceM3 
     * @param id_katios 
     * @param oData 
     * @param oFuncionOK 
     * @param oFuncionErr 
     */
    public m3_detalleProcesoByProceso(PostServiceM3: PostServiceM3, id_katios: string, oData: any,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getWithBodyM3('M3/m3_detalleProcesoByProceso/' + id_katios, oData).subscribe(resp => {
            oFuncionOK(JSON.parse(resp.toString()).RESPUESTA.Detalle);
        },
            err => {
                oFuncionErr(err);
            });
    }

    public validarExistenciaProceso(PostServiceM3: PostServiceM3, idKatios: string, data: any,
        oFuncionOK: Function, oFuncionErr: Function) {
        PostServiceM3.getWithBodyM3('M3/validarExistenciaProceso/' + idKatios, data).subscribe(resp => {
            var oProducto: any = JSON.parse(resp.toString());
            oFuncionOK(oProducto);
        },
            err => {
                //Ejecutar funcion de error
                console.log(err);
                oFuncionErr(JSON.parse(err._body).Message);
            });
    }
}